// @flow strict
import React from 'react';
import styles from './Copyright.module.scss';

type Props = {
  copyright: string,
  isMenu: boolean,
};

const Copyright = ({ copyright, isMenu = false }: Props) => (
  <div className={`${styles['copyright']} copyright ${isMenu ? 'copyright-menu' : ''}`}>
    Made with <span className={styles['copyright__heart']}>❤</span> from VN<br/>
    {copyright}
  </div>
);

export default Copyright;
